// extracted by mini-css-extract-plugin
export default {"overlay":"Welcome_overlay__XWV9p","buttons":"Welcome_buttons__-Dm1G","bold":"Welcome_bold__wfywS"};